import { cn } from '@/utils'
import type { Side } from './types'

export const SideCard = ({
  label,
  side,
  landing,
}: {
  label: string
  side: Side
  landing: boolean
}) => (
  <div className="min-w-0 flex-1 rounded-lg bg-neutral-100 px-3 py-2.5">
    <p className="mb-1 text-[11px] font-semibold uppercase tracking-wide text-neutral-600">
      {label}
    </p>
    <p
      className={cn(
        'text-base font-semibold',
        landing ? 'text-neutral-950' : 'text-neutral-700',
      )}
    >
      {side.headline}
    </p>
    {side.lines.map((line) => (
      <p key={line} className="truncate text-xs text-neutral-600">
        {line}
      </p>
    ))}
  </div>
)
